import chroma from 'chroma-js';
import { ReactNode, useMemo } from 'react';
import { ColorStep } from 'types/app.types';
import Classic from 'configs/colorScales';
import { Typography } from 'antd';
import styles from './index.module.scss';

const {
  ruler: rulerSt, scaleWrapper, step, wrapper,
} = styles;

interface ColorScaleProps {
  colors?: ColorStep[], // TODO Change! in the future this should be mandatory
  gradient?: boolean
}
function ColorScale({ gradient = false, colors = Classic.steps } : ColorScaleProps) {
  const colorsList = useMemo(() => (colors.length > 1 ? colors : Classic.steps), [colors]);
  const colorScale = useMemo(
    () => chroma.scale(colorsList.map((c) => chroma(c.color))),
    [colorsList],
  );
  const oneHundredColors = useMemo(() => colorScale.colors(100), [colorScale]);
  const scale = useMemo(() => {
    const scale : ReactNode[] = [];
    if (gradient) {
      oneHundredColors.forEach((color, index) => {
        scale.push(
          <span
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={step}
            style={{ background: color }}
          />,
        );
      });
    } else {
      for (let index = 0; index < colorsList.length; index += 1) {
        scale.push(
          <span
            key={index}
            className={step}
            style={{ background: chroma(colorsList[index].color).css() }}
          />,
        );
      }
    }
    return <div className={scaleWrapper}>{scale}</div>;
  }, [colorsList, gradient, oneHundredColors]);

  const ruler = useMemo(() => {
    const ticks : ReactNode[] = [];

    colors.forEach((c, i) => {
      ticks.push(
        // eslint-disable-next-line react/no-array-index-key
        <span key={c.threshold + i}>
          <Typography.Text style={{ left: -(6 * c.threshold.toString().length) / 2 }}>
            {c.threshold}
          </Typography.Text>
        </span>,
      );
    });

    return <div className={rulerSt}>{ticks}</div>;
  }, [colors]);

  return (
    <div className={wrapper}>
      {scale}
      {ruler}
    </div>
  );
}

export default ColorScale;
